import {
  ADD_TRAILER_FAIL,
  ADD_TRAILER_REQUEST,
  ADD_TRAILER_SUCCESS,
  DELETE_TRAILER_FAIL,
  DELETE_TRAILER_REQUEST,
  DELETE_TRAILER_SUCCESS,
  GET_SINGLE_TRAILER_FAIL,
  GET_SINGLE_TRAILER_REQUEST,
  GET_SINGLE_TRAILER_SUCCESS,
  GET_TRAILER_LIST,
  GET_TRAILER_LIST_FAIL,
  GET_TRAILER_LIST_SUCCESS,
  UPDATE_TRAILER_FAIL,
  UPDATE_TRAILER_REQUEST,
  UPDATE_TRAILER_SUCCESS,
} from "src/constants/types";

export const trailerReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_TRAILER_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_TRAILER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        trailerList: actions.payload,
        error: "",
      };
    case GET_TRAILER_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_TRAILER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_TRAILER_SUCCESS:
      return {
        ...state,
        loading: false,
        selected_trailer: actions.payload,
      };
    case GET_SINGLE_TRAILER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_TRAILER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_TRAILER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_TRAILER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_TRAILER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_TRAILER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_TRAILER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_TRAILER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_TRAILER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_TRAILER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
